import { colors } from '../../style-guide'

export const hintTheme = {
   light: {
      errorText: {
         color: colors['error-500']
      },
      hintText: {
         color: colors['gray-600']
      }
   },
   dark: {}
}
